import "styles/index.css";

import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import withUserPerm from "services/withUserPerm";
import { compose } from "redux";
import _get from "lodash/get";

import wizardAction from "../modules/wizard/actions";
import wizardSelectors from "../modules/wizard/selectors";
import mainSelectors from "../modules/main/selectors";
import AdsSelector from "../components/wizard/AdsSelector";
import AdsConfirmation from "../components/wizard/AdsConfirmation";
import styled from "styled-components";
import Section from "components/Section";

const Wizard = () => {
  const [isSelectAdsPage, setIsSelectAdsPage] = useState(true);
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const createAdsResult = useSelector((state) => wizardSelectors.createAdsResult(state));
  const dispatch = useDispatch();
  const firstLoad = useRef(true);
  let history = useHistory();

  console.log("authAdproResult", authAdproResult);
  let googleAdsList = [];
  let facebookAdsList = [];
  authAdproResult.data.allAds.forEach((item, key) => {
    if (item.type === "g_ads") {
      googleAdsList.push({
        title: item.account_name + " (" + item.ads_account_id + ")",
        value: item.ads_account_id,
      });
    } else if (item.type === "fb") {
      facebookAdsList.push({
        title: item.account_name + " (" + item.ads_account_id + ")",
        value: item.ads_account_id,
      });
    }
  });
  const [selectedGoogleAds, setSelectedGoogleAds] = useState(googleAdsList[0]);
  const [selectedFacebookAds, setSelectedFacebookAds] = useState(facebookAdsList[0]);
  console.log("googleAdsList", googleAdsList);
  console.log("facebookAdsList", facebookAdsList);

  const onSaveAds = () => {
    console.log("onSaveAds");
    setIsSelectAdsPage(false);
  };

  const onConfirm = () => {
    console.log("onConfirm");
    const rmpToken = sessionStorage.getItem("rmp_token");
    console.log("selectedGoogleAds", selectedGoogleAds);
    console.log("selectedFacebookAds", selectedFacebookAds);
    dispatch(
      wizardAction.CreateAds(rmpToken, _get(selectedGoogleAds, ["value"]), _get(selectedFacebookAds, ["value"])),
    );
  };

  const onCancel = () => {
    console.log("onCancel");
    setIsSelectAdsPage(true);
  };

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    } else if (!createAdsResult.result) {
      console.log("go loading");
      history.replace("/");
    } else {
      console.log("create ads error");
      history.replace("/");
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAdsResult.result]);

  return (
    <StyledContainer>
      <Section className="section">
        {isSelectAdsPage ? (
          <AdsSelector
            googleAdsList={googleAdsList}
            facebookAdsList={facebookAdsList}
            onSelectGoogle={setSelectedGoogleAds}
            onSelectFacebook={setSelectedFacebookAds}
            onSaveAds={onSaveAds}
          />
        ) : (
          <AdsConfirmation
            selectedGoogleAds={selectedGoogleAds}
            selectedFacebookAds={selectedFacebookAds}
            onConfirm={onConfirm}
            onCancel={onCancel}
            businessName={authAdproResult.data.name}
          />
        )}
      </Section>
    </StyledContainer>
  );
};

export default compose(withUserPerm("wizard"))(Wizard);

const StyledContainer = styled.div`
  height: calc(100vh - 107px);
  display: flex;
  align-items: center;
  justify-content: center;

  > .section {
    width: 300px;
    box-sizing: border-box;
  }

  @media screen and (max-width: 834px) {
    height: calc(100vh - 70px);
    margin: 0 8px;
    padding: 0 0 62px;
    box-sizing: border-box;

    > .section {
      margin: 0 16px;

      .dropdown-button {
        min-width: unset;
      }
    }
  }
`;
